import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getAllProvinces = async function() {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getAllDistrict = async function() {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getDistrictByProvince = async function(provinceId) {
            let result = [];
            try {
                // const response =  await this.$http.get('/province/province/' + provinceId);
                const response = await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API + provinceId);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }
                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getProvincesByContext = async function(contextId) {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_CONTEXT_URL + contextId);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data.provinces)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getDistrictByContext = async function(contextId, provinceID) {
            let result = [];
            try {
                const response = await this.$http.get('/api/getDistrictsByContext/' + contextId + '?provinceID=' + provinceID);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };
    },
};